const router = [
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('./Aboutus'),
  },
]

export default router
